import { FormControl, FormLabel, Typography, Table, TableHead, TableRow, TableCell, TableBody, Radio } from '@mui/material';
import { ControllerRenderProps, FieldError } from 'react-hook-form';
import { SelectionRangeTableOption, SelectionRangeTableValue } from '../types/FormField';

export interface SelectionRangeTableFieldProps {
  name: string;
  label: string;
  disabled?: boolean;
  value: SelectionRangeTableValue;
  onChange: ControllerRenderProps['onChange'];
  options: SelectionRangeTableOption[];
  error?: FieldError;
  readOnly?: boolean;
}

export const SelectionRangeTableField = ({
  name,
  label,
  disabled = false,
  value,
  onChange,
  options,
  error,
  readOnly = false,
}: SelectionRangeTableFieldProps) => {
  const handleValueChange = (name: string, optionValue: number) => {
    const newValue = value || {};
    newValue[name] = optionValue;
    onChange(newValue);
  };

  return (
    <>
      <FormControl fullWidth size="small" sx={{ overflowX: 'auto' }}>
        {label && (
          <FormLabel id={`${name}-label`} disabled={disabled}>
            {label}
          </FormLabel>
        )}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              {Array.from({ length: 10 }, (_, i) => (
                <TableCell key={i + 1} sx={{ textAlign: 'center' }}>
                  {i + 1}
                </TableCell>
              ))}
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {options.map(({ name: optionName, leftLabel, rightLabel }) => (
              <TableRow key={optionName}>
                <TableCell>{leftLabel}</TableCell>

                {Array.from({ length: 10 }, (_, i) => {
                  const optionValue = i + 1;
                  return (
                    <TableCell key={i + 1} sx={{ textAlign: 'center' }}>
                      <Radio
                        name={optionName}
                        value={optionValue}
                        checked={value?.[optionName] === optionValue}
                        onChange={() => handleValueChange(optionName, optionValue)}
                        disabled={disabled || readOnly}
                      />
                    </TableCell>
                  );
                })}
                <TableCell>{rightLabel}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </FormControl>
      {error ? (
        <Typography variant="caption" color="error">
          {error!.message as string}
        </Typography>
      ) : (
        <br />
      )}
    </>
  );
};
